import { IS_NATIVE } from '~/utils/platform'
import { NATIVE_SIGNIN_NUDGE_KEY } from '~/utils/nativePersistence'

/** A dismissible native modal on the first wallet earn. Recovery is
 * different: a lost auth session always needs a visible way back to sign-in. */
export function useNativeIdentityNudge() {
  const reason = useState<'earn' | 'recovery' | null>('native-identity-nudge', () => null)
  const user = useAuthUser()
  const visible = computed(() => IS_NATIVE && !!reason.value && (!user.value || user.value.anonymous))
  function firstEarn() {
    if (!IS_NATIVE || useAuthUser().value && !useAuthUser().value?.anonymous) return
    try {
      if (localStorage.getItem(NATIVE_SIGNIN_NUDGE_KEY)) return
      localStorage.setItem(NATIVE_SIGNIN_NUDGE_KEY, '1')
    } catch { /* still offer protection if the hot store is unavailable */ }
    reason.value = 'earn'
  }
  function recover() { if (IS_NATIVE) reason.value = 'recovery' }
  function dismiss() { reason.value = null }
  return { reason, visible, firstEarn, recover, dismiss }
}
